import { Button, Grid } from '@mui/material';
import React from 'react';
import { useStakingContext } from '../../contexts/staking.context';

export const ClaimInput = ({ vault }) => {
  const { harvest, handleUnstake } = useStakingContext();

  const onClickClaim = async () => {
    if (vault.ozkEarned > 0) {
      await harvest(vault.yieldContract, vault.stakingContract);
    }
  };
  return (
    <Grid
      item
      lg={3.4}
      md={3.8}
      sm={12}
      xs={12}
      sx={{
        padding: '8px 16px',
        borderRadius: '12px',
        border: '1px solid #5F4C3E',
      }}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid gap="4px" display="flex" flexDirection="column">
        <p className="text-white font-poppins text-xs font-normal leading-5">
          OZK EARNED
        </p>
        <p className="text-[#9CA3AF] font-poppins text-xl font-bold leading-8">{`${vault.ozkEarned} OZK`}</p>
      </Grid>
      <Grid
        gap="4px"
        display="flex"
        flexDirection={{ lg: 'row', md: 'column', sm: 'column', xs: 'column' }}
        lg={7}
        md={8}
        sm={3}
        xs={3}
      >
        <Button
          sx={{
            height: '39px',
            width: 'auto',
            background: 'transparent',
            border: '1px solid  #FC9D4B',
            borderColor: '#FC9D4B',
            borderRadius: '25px',
            color: '#FFFFFF',
            fontWeight: 'semibold',
            fontFamily: 'PoppinsRegular',
            fontSize: { lg: '18px', md: '14px' },
            padding: '7px 15px',
            '&:hover': {
              background:
                'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
            },
            textTransform: 'none',
            '&.Mui-disabled': {
              background: 'transparent',
              border: '1.5px solid #A3A3B3',
              color: '#A3A3B3',
              boxShadow: 'none',
              cursor: 'not-allowed',
            },
          }}
          disabled={vault.ozkEarned <= 0}
          onClick={onClickClaim}
        >
          Claim
        </Button>
        <Button
          sx={{
            height: '39px',
            width: 'auto',
            background: 'transparent',
            border: '1px solid  #FC9D4B',
            borderColor: '#FC9D4B',
            borderRadius: '25px',
            color: '#FFFFFF',
            fontWeight: 'semibold',
            fontFamily: 'PoppinsRegular',
            fontSize: { lg: '18px', md: '14px' },
            padding: '7px 15px',
            '&:hover': {
              background:
                'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
              boxShadow: '0px 0px 13px 1px #FC9D4B',
            },
            textTransform: 'none',
            '&.Mui-disabled': {
              background: 'transparent',
              border: '1.5px solid #A3A3B3',
              color: '#A3A3B3',
              boxShadow: 'none',
              cursor: 'not-allowed',
            },
          }}
          onClick={() => handleUnstake(vault)}
          disabled={vault.ozkStaked === 0 || !vault.userCanUnstake}
        >
          Unstake
        </Button>
      </Grid>
    </Grid>
  );
};
